import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const CourseAPI = {
	getOrganizationCourses: (req: OrganizationCoursesRequest) => {
		return axios.get(`${apiUrl}/organizations/${req.organizationId}/courses`)
			.then((response) => response.data as CourseWithLocationNameDTO[]);
	},

	getLocationCourses: (req: LocationCoursesRequest) => {
		return axios.get(`${apiUrl}/organizations/${req.organizationId}/locations/${req.locationId}/courses`)
			.then((res) => res.data as CourseWithLocationNameDTO[]);
	},

	getOrganizationCourse: (organizationCourseRequest: OrganizationCourseRequest) => {
		return axios.get(`${apiUrl}/organizations/${organizationCourseRequest.organizationId}/courses/${organizationCourseRequest.courseId}`)
			.then((response) => response.data as CourseDTO);
	},

	postOrganizationCourse: (OrganizationCourseUpsertRequest: OrganizationCourseUpsertRequest) => {
		return axios.post(
			`${apiUrl}/organizations/${OrganizationCourseUpsertRequest.organizationId}/courses/${OrganizationCourseUpsertRequest.id}`,
			OrganizationCourseUpsertRequest
		)
			.then(res => res);
	},

	postLocationXrefCourse: (req: OrganizationCourseAddLocationRequest) => {
		return axios.post(
			`${apiUrl}/organizations/${req.organizationId}/courses/${req.courseId}/add-location`, { locationId: req.locationId }
		)
			.then(res => res.data as boolean);
	},

	getLocationForCourseRequest: (req: GetLocationForCourseRequest) => {
		return axios.get(
			`${apiUrl}/organizations/${req.organizationId}/courses/${req.courseId}/get-location`
		)
			.then(res => res.data as LocationDTO);
	}

};

export default CourseAPI;